export enum PaymentTransactionStatus {
    Paid = 'Paid',
    Failed = 'Failed',
    Cancelled = 'Cancelled',
    InProcess = 'In Process',
    Scheduled = 'Scheduled',
    Refund = 'Refund',
    Void = 'Void',
}
